
export const mapboxConfig = {
    accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
    // Add other configurations or default settings for Mapbox here
};